import { create } from 'zustand';

const useStudentDetailStore = create((set) => ({
    studentDetail: {},

    setStudentDetail: (newDetail) => set({ studentDetail: newDetail }),

    clearStudentDetail: () => set({ studentDetail: {} }),
}));

export default useStudentDetailStore;
